import $ from 'jquery';
import Swal from 'sweetalert2';

import { lang, tr } from '../../utils/helpers';

export const benefiteds = () => {
  const $form = document.getElementById('form-report');
  const $total_benefit = document.querySelector('[name="total_benefit"]');
  const $not_applicable = document.querySelector('[name="not_applicable"]');

  $form.addEventListener('submit', e => {
    if (!$total_benefit.value.length && !$not_applicable.checked) {
      e.preventDefault();
      Swal.fire(tr[lang].modal_error_attention, tr[lang].modal_error_fields, 'error');
    }
  });
};
